import { PATH_DOCS } from '@/constants';
import { Button } from '@/components/ui/button';
import { BookText, DatabaseIcon, ExternalLink, Wand } from 'lucide-react';
import { Link } from 'react-router-dom';

// Config สำหรับ documentation links
const DOC_LINKS = [
  {
    title: 'Quick Start',
    description: 'Get started with Serverless GPU',
    url: PATH_DOCS.quickStart,
    icon: BookText,
  },
  {
    title: 'Mode',
    description: 'Learn about different modes',
    url: PATH_DOCS.mode,
    icon: Wand,
  },
  {
    title: 'File Storage',
    description: 'Manage your files and storage',
    url: PATH_DOCS.storage,
    icon: DatabaseIcon,
  },
];

// Alternative Design 2: Horizontal Cards (uncomment to use)

export const DocLinkCardHorizontal = ({
  title,
  description,
  url,
  icon: Icon,
}: {
  title: string;
  description: string;
  url: string;
  icon: React.ComponentType<{ className?: string }>;
}) => (
  <Link
    to={url}
    className="group flex items-start gap-4 rounded-lg border border-border/50 bg-card p-4 transition-all duration-300 hover:border-primary/50 hover:bg-accent/50 hover:shadow-lg"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted p-2">
      <Icon className="h-5 w-5 text-muted-foreground transition-colors group-hover:text-primary" />
    </div>

    <div className="flex-1">
      <h4 className="font-semibold text-foreground transition-colors group-hover:text-primary">
        {title}
      </h4>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>

    <ExternalLink className="h-4 w-4 text-muted-foreground transition-colors group-hover:text-primary" />
  </Link>
);

const ServerlessOverviewDoc = () => {
  return (
    <div className="space-y-8">
      <div className="space-y-1.5">
        <div className="text-base font-semibold">Documentation</div>
        <p className="text-sm text-muted-foreground">
          Explore our comprehensive documentation to get the most out of
          Serverless GPU
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {DOC_LINKS.map((link) => (
          <DocLinkCardHorizontal
            key={link.title}
            title={link.title}
            description={link.description}
            url={link.url}
            icon={link.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default ServerlessOverviewDoc;
